import axios from 'axios';
import { DOCUMENTS } from '../constantes';
export const GET_DOCUMENTS = 'GET_DOCUMENTS';
export const GET_DOCUMENTS_ID = 'GET_DOCUMENTS_ID';
export const POST_DOCUMENTS = 'POST_DOCUMENTS';
export const PUT_DOCUMENTS = 'PUT_DOCUMENTS';
export const DELETE_DOCUMENTS = 'DELETE_DOCUMENTS';
export const SIETE_DIAS = 'SIETE_DIAS';
export const SALDOS = 'SALDOS';
export const PUT_ARMADO_ENTREGADO = 'PUT_ARMADO_ENTREGADO';
export const NO_APROBADOS = "NO_APROBADOS";
export const PUT_APROBAR_DESAPROBAR = "APROBAR_DESAPROBAR";
export const GET_APPROVED = "GET_APPROVED";
export const GET_ARMADO = "GET_ARMADO";
export const PUT_ARMADO = "PUT_ARMADO";

axios.defaults.withCredentials = true;

export const getDocuments = () => async dispatch => {
    await axios.get(DOCUMENTS, {withCredentials:true})
        .then((res) => {
            dispatch({
                type: GET_DOCUMENTS,
                payload: res.data
            })
        })
        .catch((err) => {console.log(err)})
} 

export const getDocumentsId = (id) => async dispatch => {
    //console.log(id)  "https://sistemaandyback-production.up.railway.app/api/documents/" + id
    try {
        await axios.get(`${DOCUMENTS}/${id}`, {withCredentials:true}) 
        .then(res => {
            dispatch({
                type: GET_DOCUMENTS_ID,
                payload: res.data
            })
            //console.log(res.data)
        })
    } catch (error) {
        console.log(error)
    }
}

export const getApproved = () => async dispatch =>{
    try {
        await axios.get(`${DOCUMENTS}/approved`)
        .then(res => {
            dispatch({
                type: GET_APPROVED,
                payload: res.data
            })
            console.log(res.data)
        })
    } catch (error) {
        console.log(error)
    }
}


export const getArmado = () => async dispatch =>{
    try {
        await axios.get(`${DOCUMENTS}/armado`)
        .then(res => {
            dispatch({
                type: GET_ARMADO,
                payload: res.data
            })
            console.log(res.data)
        })
    } catch (error) {
        console.log(error)
    }
}

export const putArmado = (id, payload) => async dispatch => {
    console.log(id)
    try {
        await axios.put(`${DOCUMENTS}/approved/armado/${id}`, payload)
        .then(res => {
            dispatch({
                type: PUT_ARMADO,
                payload: res.data
            })
            console.log(res.data)
        })
    } catch (error) {
        console.log(error)
    }
}




export const postDocuments = (payload) => async dispatch => {
    try {
        await axios.post(DOCUMENTS, payload, {withCredentials:true})
        .then((res) => {
            dispatch({
                type: POST_DOCUMENTS,
                payload: res.data
            })
            //console.log(res.data)
        })
    } catch (error) {
        return (error)        
    }
}

export const putDocuments = (id, payload) => async dispatch => {
    console.log(id, payload) // "https://sistemaandyback-production.up.railway.app/api/documents/" + id, payload
    try {
        await axios.put(`${DOCUMENTS}/${id}`, payload, {withCredentials:true})
        .then(res => {
            dispatch({
                type: PUT_DOCUMENTS,
                payload: res.data
            })
            //console.log(res.data)
        })
    } catch (error) {
        return (error)       
    }
}

export const armadoEntregado = (payload) => async dispatch => {
    console.log(payload)
    try {
        await axios.put(DOCUMENTS, payload,  {headers: {
            'Content-Type': 'application/json',
        }, withCredentials:true})
        .then(res => {
            dispatch({
                type: PUT_ARMADO_ENTREGADO,
                payload: res.data
            })
        })
    } catch (error) {
        console.log("error put", error);
        
    }
}

export const aprobarDesaprobar = (id, payload) => async dispatch => {
    console.log(id, payload)
    try {
        await axios.put(`${DOCUMENTS}/approved/${id}`, payload)
        .then(res => {
            dispatch({
                type: PUT_APROBAR_DESAPROBAR,
                payload: res.data
            })            
        })
    } catch (error) {
        
    }
}


export const deleteDocuments = (id) => async dispatch => {
    console.log(id)
    try {
        await axios.delete(`${DOCUMENTS}/${id}`, {withCredentials:true})
        .then(res => {
            dispatch({
                type: DELETE_DOCUMENTS,
                payload: res.data
            })
        })
    } catch (error) {
        
    }
}

export function sieteDias(payload){
    console.log(payload)
    return{
        type: SIETE_DIAS,
        payload
    }
}

export function saldos(payload){
    console.log(payload)
    return{
        type: SALDOS,
        payload
    }
}

export function noAprobados(payload){
    //console.log(payload)
    return {
        type: NO_APROBADOS,
        payload
    }
}

